import React, { Component } from 'react'
import axios from 'axios'
import cx from 'classnames'
import { Link } from 'react-router-dom'
import { css } from 'react-emotion'
import { FadeLoader } from 'react-spinners'
import PropTypes from 'prop-types'
import { getHeaders, healthUrl } from '../../../config'

import WithUser from 'hocs/WithUser'
import HealthUserPolicyCard from './HealthUserPolicyCard'
import policyIcon from 'img/policy-icon.svg'

class MyHealthPolicies extends Component {
  state = {
    loadingHealth: true,
    unpaidHealthPolicies: [],
    activeHealthPolicies: [],

    width: 0,
    height: 0
  }

  async componentDidMount() {
    try {
      let {
        data: { results }
      } = await axios.get(healthUrl, {
        headers: getHeaders()
      })
      let unpaidHealthPolicies = results.filter(
        policy => policy.status === 'U' && policy.premium !== null
      )

      let activeHealthPolicies = results.filter(
        policy => policy.status !== 'U' && policy.premium !== null
      )

      this.setState({
        unpaidHealthPolicies,
        activeHealthPolicies,
        loadingHealth: false
      })
    } catch (err) {
      console.error(err)
    }

    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight })
  }

  handleMakeClaim = () => {
    this.props.makeClaim()
    this.props.openModal()
  }

  handleMakeCancellation = () => {
    this.props.makeCancellation()
    this.props.openModal()
  }

  render() {
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `
    return (
      <div className="user-dash__main">
        <p className="site-content__lead">
          Purchased Health Insurance Policies
        </p>
        <p className="text--muted mb-2rem">Click any policy to see more.</p>
        <hr />

        {this.state.loadingHealth ? (
          <div className="mt-3rem">
            <FadeLoader
              className={override}
              sizeUnit={'px'}
              size={150}
              color={'#13d1cf'}
            />
          </div>
        ) : this.state.activeHealthPolicies.length ? (
          <div className="mt-2rem flex-row flex-wrap">
            {this.state.activeHealthPolicies.map(policy => (
              <HealthUserPolicyCard key={policy.id} policy={policy} />
            ))}
          </div>
        ) : (
          <div className="mt-2rem flex-row flex-wrap">
            {this.state.width > 767 ? (
              <img src={policyIcon} alt="policy-icon" />
            ) : null}
            <p className={cx(this.state.width > 767 ? 'ml-2rem' : null)}>
              <span className="mr-2rem">You have no active policies.</span>
              <button
                className={cx(
                  'btn btn--gradient-border',
                  this.state.width > 767 ? null : 'mt-1rem'
                )}
              >
                <Link to="/buy-health-insurance">Buy Health Insurance</Link>
              </button>
            </p>
          </div>
        )}

        <div className="mb-5rem" />

        <p className="site-content__lead">Unpaid Health Insurance Policies</p>
        <p className="text--muted mb-2rem">Click on any policy to pay</p>

        <hr />
        {this.state.loadingHealth ? (
          <div className="mt-3rem">
            <FadeLoader
              className={override}
              sizeUnit={'px'}
              size={150}
              color={'#13d1cf'}
            />
          </div>
        ) : this.state.unpaidHealthPolicies.length ? (
          <div className="mt-2rem flex-row flex-wrap">
            {this.state.unpaidHealthPolicies.map(policy => (
              <HealthUserPolicyCard key={policy.id} policy={policy} />
            ))}
          </div>
        ) : (
          <div className="mt-2rem flex-row flex-wrap">
            {this.state.width > 767 ? (
              <img src={policyIcon} alt="policy-icon" />
            ) : null}
            <p className={cx(this.state.width > 767 ? 'ml-2rem' : null)}>
              <span className="mr-2rem">You have no unpaid policies.</span>
              <button
                className={cx(
                  'btn btn--gradient-border',
                  this.state.width > 767 ? null : 'mt-1rem'
                )}
              >
                <Link to="/buy-health-insurance">Buy Health Insurance</Link>
              </button>
            </p>
          </div>
        )}
      </div>
    )
  }
}
MyHealthPolicies.propTypes = {
  authUser: PropTypes.shape({
    token: PropTypes.string
  }),
  makeClaim: PropTypes.func,
  openModal: PropTypes.func,
  makeCancellation: PropTypes.func
}

export default WithUser(MyHealthPolicies)
